// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UDU7","input":"styles_input__1mTId"};